// Export UI components
export * from './components/table/table';
export * from './components/table/table-body';
export * from './components/table/table-column';
export * from './components/table/table-header';
export * from './components/icon/icon';
export * from './components/popover/popover';
export * from './components/tooltip/tooltip';
export * from './components/alert/alert';
export * from './components/popconfirm/popconfirm';
export * from './components/message/message';
export * from './components/upload/upload';
export * from './components/modal/modal';
export * from './components/form/form-item';
export * from './components/form/form-datepicker';
export * from './components/collapse/collapse';
export * from './components/collapse/panel';
export * from './components/select/select';
export * from './components/datepicker/datepicker';

// Export directives
export * from './directives/index';

import Multiselect from 'vue-multiselect';

import '../../styles/styles.scss';

export { Multiselect };



// WEBPACK FOOTER //
// node_modules/wc-lib/src/wc-ui/index.ts